import React from 'react';
import { Link } from 'gatsby';
import { Body, Box, Heading } from '@hover/blueprint';
import { ArrowButton } from '@hover/shared-components';
import { chakra } from '@chakra-ui/react';
import type { ISolutionPoints } from '../../../../interfaces/ISolutionPoints';
import ThickCheckmark from '../../../../assets/svgs/ThickCheckmark';

interface IPointContentsProps
  extends Pick<ISolutionPoints, 'heading' | 'items' | 'url' | 'urlTitle'> {
  pointsGap?: string;
  pointsGapMobile?: string;
}

const PointContents: React.FC<IPointContentsProps> = ({
  heading,
  items,
  url,
  urlTitle,
  pointsGap,
  pointsGapMobile,
}) => {
  const CustomCheckmark = chakra(ThickCheckmark, {
    baseStyle: {
      mr: 4,
    },
  });

  const renderArrowButton = () => {
    if (!url) return undefined;

    if (typeof url === 'string')
      return (
        <ArrowButton
          flex={0}
          mt={8}
          variant="minimal"
          whiteSpace="nowrap"
          ml={200}
          as={Link}
          to={url}
        >
          {urlTitle}
        </ArrowButton>
      );

    return (
      <ArrowButton
        flex={0}
        mt={8}
        variant="minimal"
        whiteSpace="nowrap"
        onClick={url}
        ml={200}
      >
        {urlTitle}
      </ArrowButton>
    );
  };

  return (
    <Box
      flexDir="column"
      maxW={{ base: 'auto', desktop: '500px' }}
      alignItems="flex-start"
    >
      <Heading
        isLight
        marginBottom={{ base: 400, tablet: 400 }}
        size={{ base: 500, tablet: 600 }}
      >
        {heading}
      </Heading>
      <Box
        flexDirection="column"
        gap={
          pointsGap
            ? { base: pointsGapMobile || pointsGap, tablet: pointsGap }
            : 400
        }
      >
        {items.map(item => (
          <Box flexDir="row" key={item.id}>
            <CustomCheckmark />
            {typeof item.content === 'string' ? (
              <Body flex={1} size={500}>
                {item.content}
              </Body>
            ) : (
              item.content
            )}
          </Box>
        ))}
      </Box>
      {renderArrowButton()}
    </Box>
  );
};

export default PointContents;
